import { render, staticRenderFns } from "./Tradmanage-details.vue?vue&type=template&id=8169d608&scoped=true&"
import script from "./Tradmanage-details.vue?vue&type=script&lang=js&"
export * from "./Tradmanage-details.vue?vue&type=script&lang=js&"
import style0 from "./Tradmanage-details.vue?vue&type=style&index=0&id=8169d608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8169d608",
  null
  
)

export default component.exports